import React, { PureComponent } from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';
import SelectValueUtil, {
  SupportedArrayTypes,
  SupportedTypes,
  SupportedItemType,
} from './SelectValueUtil';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Checkbox } from '@lifeomic/chroma-react/components/Checkbox';
import { getTestProps } from '../../../../../util/testProps';
import getSurveyItemTestId from '../../../util/getSurveyItemTestId';
import { v4 as uuid } from 'uuid';

const styles = (theme: Theme) =>
  createStyles({
    label: {
      color: theme.palette.black[800],
      fontSize: theme.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
    },
    labelContainer: {},
    checkbox: {
      marginTop: theme.spacing(2),
    },
  });

export interface CheckboxListFieldOwnProps {
  itemType: SupportedItemType;
  value: SupportedTypes | SupportedArrayTypes;
  onChange: (value: SupportedTypes | SupportedArrayTypes) => void;
  options: SupportedArrayTypes;
  label?: string;
  disabled?: boolean;
  error?: string;
  linkId?: string;
  className?: string;
}

type CheckboxListFieldProps = CheckboxListFieldOwnProps &
  WithStyles<typeof styles>;

class CheckboxListField extends PureComponent<CheckboxListFieldProps> {
  private _idPrefix: string;
  constructor(props: CheckboxListFieldProps) {
    super(props);

    this._idPrefix = uuid();
  }

  getValueUtil = (): SelectValueUtil =>
    new SelectValueUtil(
      {
        isMultiSelect: true,
        isOpenChoice: false,
        itemType: this.props.itemType,
      },
      this.props.options,
      this.props.value,
    );

  render() {
    const { label, disabled, linkId, className, classes } = this.props;

    const valueUtil = this.getValueUtil();
    return (
      <Box
        fullWidth
        direction="column"
        className={className}
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        {...getTestProps(getSurveyItemTestId(linkId, 'checkboxList'))}
      >
        <Box fullWidth direction="column" className={classes.labelContainer}>
          <Text size="body" className={classes.label}>
            {label}
          </Text>
        </Box>
        {valueUtil.configuredSelectOptions.map((_, index) => {
          const isSelected = valueUtil.multiSelectValue.includes(
            _.displayValue.value,
          );
          return (
            <Checkbox
              id={`${this._idPrefix}-${index}`}
              key={index}
              checked={isSelected}
              label={_.displayValue.display}
              disabled={disabled}
              className={classes.checkbox}
              onChange={() => {
                const newValue = (valueUtil.multiSelectValue || []).filter(
                  curValueEntry => curValueEntry !== _._displayValue.value,
                );
                if (!isSelected) {
                  newValue.push(_._displayValue.value);
                }
                const newFormValue =
                  valueUtil.processMultiSelectChange(newValue);
                this.props.onChange(newFormValue);
              }}
              {...getTestProps(
                getSurveyItemTestId(
                  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
                  linkId,
                  `checkboxOption-${_.displayValue.value}`,
                ),
              )}
            />
          );
        })}
      </Box>
    );
  }
}

export default withStyles(styles)(CheckboxListField);
